import React from 'react';
import './Schedule.css';
import { FormatDate } from "../../components/DataTable/DataTableContainer";
import RoutesConsts from "../../consts/RoutesConsts";
import { ContainerService } from '../../services/container';
import ApiDataTable from '../../components/ApiDataTable/ApiDataTable'
import Page from '../../components/Page/Page';

const Schedule: React.FC = () => {

  const columns = [
    {
      name: 'Id',
      selector: 'id',
      sortable: true,
    },
    {
      name: 'Criado por',
      selector: 'people.name',
      sortable: true,
    },
    {
      name: 'Inicia em',
      selector: 'scheduleStartAt',
      sortable: true,
      cell: (row: any) => FormatDate(row.scheduleStartAt),
    },
    {
      name: 'Termina em',
      selector: 'scheduleEndAt',
      sortable: true,
      cell: (row: any) => FormatDate(row.scheduleEndAt),
    },
    {
      name: 'Criado em',
      selector: 'createdAt',
      sortable: true,
      cell: (row: any) => FormatDate(row.createdAt),
    },
    {
      name: 'Atualizado em',
      selector: 'updatedAt',
      sortable: true,
      cell: (row: any) => FormatDate(row.updatedAt),
    }
  ];

  const include: any = [{ relation: 'people' }]

  const containerService = new ContainerService().build()

  return (
    <Page
      title={'Agendamentos'}
      backToRoute={RoutesConsts.MAIN}
    >
      <ApiDataTable
        include={include}
        routeCreate={RoutesConsts.SCHEDULE_FORM}
        countService={(params: any) => containerService.scheduleApiService.getSchedulesCount(params)}
        getService={(filter: any) => containerService.scheduleApiService.getSchedules(filter)}
        deleteRow={(filter: any) => containerService.scheduleApiService.deleteSchedule(filter)}
        columns={columns} />
    </Page>
  );
};

export default Schedule;